// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.boxcontainer {
  border-radius: 8px;
  height: 6rem;
  display: flex;
  justify-content: space-between !important;
  align-items: center !important;
  text-align: center !important;
  font-size: 0.9rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
}

.dark .boxcontainer {
  background-color: #353a50;
  color: white;
}
.light .boxcontainer {
  background-color: white;
  color: black;
}

.dark .title-text {
  font-weight: bold;
  color: white;
}
.light .title-text {
  font-weight: bold;
  color: black;
}

.title-text {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.redeemBtn {
  width: 20%;
  margin-right: 5rem;
  height: 5vh;
  background-color: #5271ff !important;
  border-radius: 10px;
  color: white;
  border: none;
  font-weight: bold;
  cursor: pointer;
  box-shadow: #5271ff 0px 3px 5px -2px !important;
  letter-spacing: 1px;

}

.redeemBtn:hover {
  box-shadow: none !important;
}

.proceed-wrapper-box{
  padding: 5px;
  width: 100%;
}

.loyalty-container {
  margin-top: 0;
  /* padding: 1vh 0vw 0vh 3vw; */
  height: calc(100vh - 3.2rem - 3.5rem);
}

.loyalty-sticky-header {
  position: sticky;
  top: 3.2rem;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 1rem;
  height: 3.5rem;
  padding: 0 1rem;
  border-bottom: 1px solid rgba(226, 232, 240, 0.7);
  background-color: rgba(248, 250, 252, 0.9);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.dark .loyalty-sticky-header {
  border-bottom: 1px solid rgba(51, 65, 85, 0.7);
  background-color: rgba(15, 23, 42, 0.9);
}

.loyalty-back-button {
  display: flex;
  height: 2.5rem;
  width: 2.5rem;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  border: none;
  background-color: #f1f5f9;
  cursor: pointer;
  transition: background-color 0.2s ease;
  flex-shrink: 0;
}

.dark .loyalty-back-button {
  background-color: #1e293b;
}

.loyalty-back-button:hover {
  background-color: #e2e8f0;
}

.dark .loyalty-back-button:hover {
  background-color: #334155;
}

.loyalty-back-button svg {
  height: 1.25rem;
  width: 1.25rem;
  color: #64748b;
  stroke: currentColor;
  transition: color 0.3s ease;
}

.dark .loyalty-back-button svg {
  color: #94a3b8;
}

.loyalty-header-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.dark .loyalty-header-title {
  color: #f8fafc;
}

.loyalty-container .dark {
  background-color: #2b2f42;
}

.loyalty-container .light {
  background-color: rgb(239, 240, 241);
}

.reward-container {
  margin-top: 3.2rem;
  padding: 1vh 1vw 0vh 3vw;
  padding-bottom: 50px;
  margin-bottom: 50px;
  width: 100%;
  position: relative;
}

.enter-number {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
}

.dark .enter-number {
  color: white;
}

.item-container {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.search-txt-input-wrapper {
  margin-bottom: 1rem !important;
}

.left-loyalty-container {
  padding: 1vw;
  display: flex;
  flex-direction: column !important;
}

@media (max-width: 576px) {
  .left-loyalty-container {
    padding: 3vw;
  }
}

.left-wrapper-Container {
  padding-right: 5px;
}

.table thead tr {
  background-color: #dddddd;
  color: #ffffff;
  text-align: left;
}
.table th,
.table td {
  padding: 12px 15px;
}

.table tbody tr {
  border-bottom: 1px solid #dddddd;
}

.table tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}

.table tbody tr:last-of-type {
  border-bottom: 2px solid #dddddd;
}

.table tbody tr.active-row {
  font-weight: bold;
  color: #dddddd;
}
.dark .leftContainer {
  color: #fff !important;
}

.dark .icon-btn-point {
  color: #fff !important;
}

.redeem-table-wrapper{
  color: #fff !important;
}

.dark .redeem-table-wrapper {
  background-color: #2b2f42 !important;
  color: #fff !important;
}

.dark .MuiOutlinedInput-input {
  color: #fff !important;
}

.dark .MuiTableCell-root {
  color: #fff !important;
  background-color: #2b2f42 !important;
  border: 1px solid #fff !important;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/Points.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yCAAyC;EACzC,8BAA8B;EAC9B,6BAA6B;EAC7B,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,+CAA+C;EAC/C,mBAAmB;;AAErB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,iDAAiD;EACjD,0CAA0C;EAC1C,2BAA2B;EAC3B,mCAAmC;EACnC,8DAA8D;AAChE;;AAEA;EACE,8CAA8C;EAC9C,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,iCAAiC;AACnC","sourcesContent":[".boxcontainer {\n  border-radius: 8px;\n  height: 6rem;\n  display: flex;\n  justify-content: space-between !important;\n  align-items: center !important;\n  text-align: center !important;\n  font-size: 0.9rem;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);\n}\n\n.dark .boxcontainer {\n  background-color: #353a50;\n  color: white;\n}\n.light .boxcontainer {\n  background-color: white;\n  color: black;\n}\n\n.dark .title-text {\n  font-weight: bold;\n  color: white;\n}\n.light .title-text {\n  font-weight: bold;\n  color: black;\n}\n\n.title-text {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.redeemBtn {\n  width: 20%;\n  margin-right: 5rem;\n  height: 5vh;\n  background-color: #5271ff !important;\n  border-radius: 10px;\n  color: white;\n  border: none;\n  font-weight: bold;\n  cursor: pointer;\n  box-shadow: #5271ff 0px 3px 5px -2px !important;\n  letter-spacing: 1px;\n\n}\n\n.redeemBtn:hover {\n  box-shadow: none !important;\n}\n\n.proceed-wrapper-box{\n  padding: 5px;\n  width: 100%;\n}\n\n.loyalty-container {\n  margin-top: 0;\n  /* padding: 1vh 0vw 0vh 3vw; */\n  height: calc(100vh - 3.2rem - 3.5rem);\n}\n\n.loyalty-sticky-header {\n  position: sticky;\n  top: 3.2rem;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  height: 3.5rem;\n  padding: 0 1rem;\n  border-bottom: 1px solid rgba(226, 232, 240, 0.7);\n  background-color: rgba(248, 250, 252, 0.9);\n  backdrop-filter: blur(24px);\n  -webkit-backdrop-filter: blur(24px);\n  transition: background-color 0.3s ease, border-color 0.3s ease;\n}\n\n.dark .loyalty-sticky-header {\n  border-bottom: 1px solid rgba(51, 65, 85, 0.7);\n  background-color: rgba(15, 23, 42, 0.9);\n}\n\n.loyalty-back-button {\n  display: flex;\n  height: 2.5rem;\n  width: 2.5rem;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px;\n  border: none;\n  background-color: #f1f5f9;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  flex-shrink: 0;\n}\n\n.dark .loyalty-back-button {\n  background-color: #1e293b;\n}\n\n.loyalty-back-button:hover {\n  background-color: #e2e8f0;\n}\n\n.dark .loyalty-back-button:hover {\n  background-color: #334155;\n}\n\n.loyalty-back-button svg {\n  height: 1.25rem;\n  width: 1.25rem;\n  color: #64748b;\n  stroke: currentColor;\n  transition: color 0.3s ease;\n}\n\n.dark .loyalty-back-button svg {\n  color: #94a3b8;\n}\n\n.loyalty-header-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n\n.dark .loyalty-header-title {\n  color: #f8fafc;\n}\n\n.loyalty-container .dark {\n  background-color: #2b2f42;\n}\n\n.loyalty-container .light {\n  background-color: rgb(239, 240, 241);\n}\n\n.reward-container {\n  margin-top: 3.2rem;\n  padding: 1vh 1vw 0vh 3vw;\n  padding-bottom: 50px;\n  margin-bottom: 50px;\n  width: 100%;\n  position: relative;\n}\n\n.enter-number {\n  display: flex;\n  flex: 1;\n  justify-content: center;\n  align-items: center;\n}\n\n.dark .enter-number {\n  color: white;\n}\n\n.item-container {\n  width: 100%;\n  display: flex;\n  justify-content: space-around;\n}\n\n.search-txt-input-wrapper {\n  margin-bottom: 1rem !important;\n}\n\n.left-loyalty-container {\n  padding: 1vw;\n  display: flex;\n  flex-direction: column !important;\n}\n\n@media (max-width: 576px) {\n  .left-loyalty-container {\n    padding: 3vw;\n  }\n}\n\n.left-wrapper-Container {\n  padding-right: 5px;\n}\n\n.table thead tr {\n  background-color: #dddddd;\n  color: #ffffff;\n  text-align: left;\n}\n.table th,\n.table td {\n  padding: 12px 15px;\n}\n\n.table tbody tr {\n  border-bottom: 1px solid #dddddd;\n}\n\n.table tbody tr:nth-of-type(even) {\n  background-color: #f3f3f3;\n}\n\n.table tbody tr:last-of-type {\n  border-bottom: 2px solid #dddddd;\n}\n\n.table tbody tr.active-row {\n  font-weight: bold;\n  color: #dddddd;\n}\n.dark .leftContainer {\n  color: #fff !important;\n}\n\n.dark .icon-btn-point {\n  color: #fff !important;\n}\n\n.redeem-table-wrapper{\n  color: #fff !important;\n}\n\n.dark .redeem-table-wrapper {\n  background-color: #2b2f42 !important;\n  color: #fff !important;\n}\n\n.dark .MuiOutlinedInput-input {\n  color: #fff !important;\n}\n\n.dark .MuiTableCell-root {\n  color: #fff !important;\n  background-color: #2b2f42 !important;\n  border: 1px solid #fff !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
